const isBreakpoint = function(breakpoint) {

    let breakpoints = {
        "phone-portrait": 321,
        "phone-landscape": 481,
        "tablet-portrait": 601,
        'tablet-landscape': 869,
        "desktop-small": 980,
        "desktop": 1000,
        "desktop-large": 1200,
    }

    if( breakpoints[breakpoint] == '' || breakpoints[breakpoint] == null ) {
        console.log('this breakpoint does not exist')
        return
    }

    let windowWidth = window.innerWidth
    let currentBreakpoint = breakpoints[breakpoint]

    if ( currentBreakpoint > windowWidth ) {
        return true
    }else{
        return false
    }
}

export default isBreakpoint
